/**
 * Routes the footer and drawer locale selectors to Orbe's country/language modal (JDTMA-745).
 *
 * The maquette's selectors are already built and styled in the theme, so rather than restyling the
 * app's own footer widget, the existing controls keep their markup and only change what they open.
 *
 * Progressive enhancement on purpose: the click is intercepted only once Orbe has defined its public
 * `mdApp_openAndRefreshModal` (declared at the top level of orbe.min.js, which is deferred). Until
 * then — or if the app is removed — the native Horizon dropdown still opens, so the control is never
 * dead. `openAndRefreshModal` rather than `openModal`: it re-reads the country and language lists
 * before showing the dialog and moves focus into it.
 *
 * Bound to `window` in the capture phase, like the gallery guards in jd-pdp.js: component.js
 * registers its delegation on `document`, also in capture, and between two capture listeners the one
 * higher up the path runs first — whatever the load order.
 */

window.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-jd-orbe-open]');
    if (!trigger) return;

    if (typeof window.mdApp_openAndRefreshModal !== 'function') return; /* native fallback */

    /* preventDefault covers the drawer's <summary>, which would otherwise toggle its <details>;
       stopPropagation keeps Horizon's own click delegation from acting on the same event. */
    event.preventDefault();
    event.stopPropagation();

    window.mdApp_openAndRefreshModal();
  },
  true
);
